export default __webpack_public_path__ + "static/media/RB_10Gal.e7d99781.jpg";